import React, { useState, useEffect, useCallback } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import MaskedInput from "react-text-mask";
import Spinner from "react-bootstrap/Spinner";
import { FaPrint } from "react-icons/fa";
import { toast } from "react-toastify";
import AfficheNote from "./AfficheNote";
import Bunexe_service from "../../../Bunexe_service";

const SaisieCodeEnregistrement = ({ info_, titre_ }) => {
  const [startLoading, setStartLoading] = useState(false);
  const [numero_correction, setNumero_Correction] = useState("1");
  const [CodeEnregistrement, setCodeEnregistrement] = useState("");
  const [liste_sieges, setListeSieges] = useState([]);
  const [symboliques, setSymboliques] = useState([]);
  const [uniqueSiege, setUniqueSiege] = useState([]);
  const [siege_choisi, setSiegeChoisi] = useState("");
  const [uneInfo, setUneInfo] = useState(null);
  const [symboliquesToSave, setSymboliquesToSave] = useState([]);

  const url_ = Bunexe_service.url;

  const entete = [
    {
      Symbolique: "Symbolique",
      Note1: "Note1",
      Note2: "Note2",
      Note3: "Note3",
    },
  ];

  const getAllSieges = useCallback(async () => {
    if (!info_?.code_dept) return;
    try {
      const response = await fetch(
        `${url_}/statistique/9af/${info_.code_dept}/siege/all_sieges`,
      );
      const data = await response.json();
      setListeSieges(data);
    } catch (error) {
      console.error("Erreur récupération sièges :", error);
      toast.error("Impossible de charger les sièges.");
    }
  }, [url_, info_?.code_dept]);

  const updateMySymbolique = useCallback((obj_symb_) => {
    if (obj_symb_) {
      const {
        symbolique,
        numero_correction: num,
        note_,
        utilisateur,
      } = obj_symb_;
      const newEntry = {
        symbolique,
        numero_correction: num,
        [`Note${num}`]: note_,
        utilisateur,
      };
      setSymboliquesToSave((prev) => [...prev, newEntry]);
    }
  }, []);

  const saveSalleSymbolique = async () => {
    if (!symboliquesToSave.length) return;

    try {
      const response = await fetch(`${url_}/saisie_notes_bac/ajouter_noteB`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(symboliquesToSave),
      });
      const data = await response.json();

      if (data.msg === "OK") {
        toast.success("Mise à jour effectuée avec succès");
        setSymboliquesToSave([]);
      } else {
        toast.error("Erreur lors de la mise à jour des notes");
      }
    } catch (error) {
      console.error("Erreur d'enregistrement :", error);
      toast.error("Erreur de connexion au serveur");
    }
  };

  const Test = async () => {
    if (!CodeEnregistrement) {
      toast.warning("Veuillez saisir un code d'enregistrement validé");
      return;
    }

    setStartLoading(true);
    try {
      const response = await fetch(
        `${url_}/saisie_notes_bac/notes/${info_.code_dept}/${numero_correction}/${CodeEnregistrement}`,
      );
      const data = await response.json();
      setStartLoading(false);

      if (!data || data.length === 0) {
        toast.warning("Pas de données, vérifiez le code d'enregistrement");
        setSymboliques([]);
        setUniqueSiege([]);
        setUneInfo(null);
        return;
      }

      const siege_unique = [...new Set(data.map((d) => d.Code_Siege))];
      if (siege_unique.length >= 1) setSiegeChoisi(siege_unique[0]);

      setUneInfo(data[0]);

      let bb = [];
      siege_unique.forEach((u) => {
        bb = [...bb, ...liste_sieges.filter((f) => f.IDSIEGE === u)];
      });

      setUniqueSiege(bb);
      setSymboliques(data);
    } catch (error) {
      setStartLoading(false);
      console.error("Erreur recherche notes :", error);
      toast.error("Erreur lors du traitement de la requête");
    }
  };

  const printTable = () => {
    const doc = new jsPDF({ format: "legal" });
    let L_titre = "";

    switch (numero_correction) {
      case "1":
        L_titre = "( NS -IV )";
        break;
      case "2":
        L_titre = "( Philo Perm. )";
        break;
      case "3":
        L_titre = "( Permanent NS-IV )";
        break;
      case "4":
        L_titre = "( Philo Trad. )";
        break;
      default:
        L_titre = "( NS -IV )";
        break;
    }

    const mydata2 = [...symboliques];
    const r6 = mydata2.filter((f) => f.Code_Siege === siege_choisi);

    if (r6.length === 0) {
      toast.error("Aucune donnée à imprimer pour ce siège.");
      return;
    }

    let serie_ = "";
    if (numero_correction === "1") {
      switch (r6[0]?.Code_Section) {
        case "1E":
          serie_ = "Lettres, Langues et Arts";
          break;
        case "1B":
          serie_ = "Sciences Economiques et Sociales";
          break;
        case "1C":
          serie_ = "Sciences, Mathématiques et Physique";
          break;
        case "1D":
          serie_ = "Sciences de la Vie et de la Terre";
          break;
        default:
          serie_ = "";
          break;
      }
    } else if (numero_correction === "2" || numero_correction === "3") {
      switch (r6[0]?.Code_Section) {
        case "2A":
          serie_ =
            numero_correction === "3" ? "Lettres, Langues et Arts" : "Philo A";
          break;
        case "2B":
          serie_ =
            numero_correction === "3"
              ? "Sciences Economiques et Sociales"
              : "Philo B";
          break;
        case "2C":
          serie_ =
            numero_correction === "3"
              ? "Sciences, Mathématiques et Physique"
              : "Philo C";
          break;
        case "2D":
          serie_ =
            numero_correction === "3"
              ? "Sciences de la Vie et de la Terre"
              : "Philo D";
          break;
        default:
          serie_ = "";
          break;
      }
    }

    doc.setFontSize(11);
    doc.setTextColor(100);

    const totalPagesExp = "{total_pages_count_string}";
    const pageWidth1 =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    const my_siej = uniqueSiege.filter((u) => u.IDSIEGE === siege_choisi);
    const Ecole_ = r6[0]?.Libelle_Matiere || "";
    const LibelleSiege_temp = my_siej[0]?.libelle_siege || "";

    doc.autoTable({
      head: entete,
      body: r6,
      startY: 52,
      showHead: "everyPage",
      didDrawPage: function (data) {
        doc.setFontSize(20);
        doc.text(
          (titre_ || "").trim().toUpperCase(),
          pageWidth1 / 2 - ((titre_ || "").trim().length * 4.2) / 2,
          22,
        );

        doc.setFontSize(14);
        const An_ = `Grille de Notes ${L_titre.trim()} - Juillet 2026`;
        doc.text(An_, 68, 28);

        doc.text(`Siège : ${LibelleSiege_temp.trim()}`, 20, 34);
        doc.text(` ${L_titre.trim()}`, 120, 38);
        doc.text(`Matière : ${Ecole_.trim()}`, 20, 40);
        doc.text(`Série : ${serie_.trim()}`, 20, 46);

        doc.setFontSize(18);
        doc.text(
          `Code d'Enreg. : ${CodeEnregistrement.trim().toUpperCase()}`,
          120,
          46,
        );

        const Lig_ =
          "_______________________________________________________________________________________";
        doc.setFontSize(10);
        doc.text(Lig_, 20, 48);
        doc.text(Lig_, 20, 49);

        let str = `Page ${doc.internal.getNumberOfPages()}`;
        if (typeof doc.putTotalPages === "function") {
          str += ` of ${totalPagesExp}     ===> Imprimé le ${new Date().toISOString()}`;
        }

        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      },
      margin: { top: 38 },
      styles: {
        lineColor: [44, 62, 80],
        lineWidth: 0.3,
      },
      headStyles: {
        fillColor: [196, 195, 199],
        fontSize: 15,
      },
    });

    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }

    const blobPDF = doc.output("blob");
    const bloburl = URL.createObjectURL(blobPDF);
    const params =
      "scrollbars=0,resizable=0,status=0,location=0,toolbar=0,menubar=0,width=1200,height=600,left=200,top=120";

    window.open(bloburl, "Impression", params);
  };

  useEffect(() => {
    getAllSieges();
  }, [getAllSieges]);

  return (
    <div className="container justify-content-center">
      <div className="row justify-content-center mt-4">
        <div className="col-xs-10 offset-xs-1 col-sm-10 col-md-8 col-lg-6 mx-auto border rounded">
          <div className="mb-4">
            <div className="row mt-2 mx-auto">
              <div
                style={{ width: "100%", marginBottom: "10px" }}
                className="d-flex justify-content-between"
              >
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="numero_correction"
                    id="correction1"
                    value="1"
                    checked={numero_correction === "1"}
                    onChange={() => {
                      setNumero_Correction("1");
                      setCodeEnregistrement("");
                      setUniqueSiege([]);
                      setUneInfo(null);
                    }}
                  />
                  <label className="form-check-label" htmlFor="correction1">
                    NS-IV
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="numero_correction"
                    id="correction3"
                    value="3"
                    checked={numero_correction === "3"}
                    onChange={() => {
                      setNumero_Correction("3");
                      setCodeEnregistrement("");
                      setUniqueSiege([]);
                      setUneInfo(null);
                    }}
                  />
                  <label className="form-check-label" htmlFor="correction3">
                    Perm. NS-IV
                  </label>
                </div>

                <div className="form-check mr-4">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="numero_correction"
                    id="correction2"
                    value="2"
                    checked={numero_correction === "2"}
                    onChange={() => {
                      setNumero_Correction("2");
                      setCodeEnregistrement("");
                      setUniqueSiege([]);
                      setUneInfo(null);
                    }}
                  />
                  <label className="form-check-label" htmlFor="correction2">
                    Perm. Philo
                  </label>
                </div>
              </div>
            </div>

            <hr />

            <div className="row py-2">
              <div className="col-xs-7 col-md-6">
                <MaskedInput
                  mask={[
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/,
                    /\d/,
                  ]}
                  className="form-control"
                  placeholder="9999-99-999"
                  value={CodeEnregistrement}
                  id="CodeEnregistrement"
                  name="CodeEnregistrement"
                  guide={true}
                  style={{
                    fontWeight: "bolder",
                    fontSize: "18px",
                    letterSpacing: "2px",
                  }}
                  onFocus={() => {
                    setCodeEnregistrement("");
                    setSymboliques([]);
                    setSymboliquesToSave([]);
                  }}
                  onChange={(e) => {
                    setCodeEnregistrement(e.target.value);
                    setUniqueSiege([]);
                    setUneInfo(null);
                  }}
                />
              </div>

              <div className="col-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={Test}
                >
                  Rech.
                </button>
              </div>

              <div className="col-3">
                {symboliques.length > 0 && (
                  <button
                    className="btn btn-small btn-primary"
                    onClick={printTable}
                  >
                    <FaPrint size={20} />
                  </button>
                )}
              </div>
            </div>

            {uneInfo && (
              <div className="row mx-2">
                <p style={{ fontWeight: "bolder", fontSize: "18px" }}>
                  Matière :{" "}
                  <span className="ml-2">{uneInfo.Libelle_Matiere}</span>
                </p>
              </div>
            )}

            <div className="row mx-2">
              {uniqueSiege.length > 0 && (
                <select
                  className="form-control"
                  name="siege_choisi"
                  value={siege_choisi}
                  onChange={(e) => setSiegeChoisi(e.target.value)}
                >
                  {uniqueSiege.map((unik, index) => (
                    <option key={index} value={unik.IDSIEGE}>
                      {unik.libelle_siege}
                    </option>
                  ))}
                </select>
              )}
            </div>

            <hr />

            <div className="container-fluid">
              {startLoading && (
                <div className="row">
                  <div className="col-8 offset-2">
                    <div className="d-flex justify-content-center align-items-center">
                      <h5 className="mr-3">Chargement en cours...</h5>
                      <Spinner animation="border" variant="info" />
                    </div>
                  </div>
                </div>
              )}

              {symboliques.length > 0 &&
                !startLoading &&
                symboliques
                  .filter((s) => s.Code_Siege === siege_choisi)
                  .map((n) => (
                    <AfficheNote
                      key={n.Symbolique}
                      une_note={n}
                      utilisateur={info_?.username}
                      updateMySymbolique={updateMySymbolique}
                      prog={numero_correction}
                    />
                  ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaisieCodeEnregistrement;
